module.exports = __webpack_public_path__ + "img/no_filter_outlined_64.e5767c54.svg";